// /////////////////////////////////////////////////////////////
// Composant pour rediriger vers une page externe


// ///////////////////////////////////
// Imports

// Imports system
import React from 'react';

// ///////////////////////////////////
// Component

const Redirect= ({to}) => {
    window.location.replace(to);
}

// ///////////////////////////////////
// Export
export default Redirect;